<template>
	<div class="container">
		<div class="row">
			<div class="col-12 col-md-12">
				<form @submit="handleSubmit" @reset="clearForm">
					<div class="row">
						<div class="col-12 mt-auto ">
							<table class="table table-borderless akkurate-skyblue pb-0 mb-2 akkurate-small ">
								<thead>
									<tr>
										<td class="fw-bolder text-center text-nowrap col-3" colspan="2"
											style="color: #006885 !important; border-bottom: 1px solid #006885; border-right: 1px solid #006885; border-style: dotted;">
											Payment Due</td>
										<td class="fw-bolder text-center col-3" colspan="2"
											style="color: #006885 !important; border-bottom: 1px solid #006885;border-right: 1px solid #006885; border-style: dotted;">
											Current Payment</td>
										<td class="fw-bolder text-center col-3" colspan="2"
											style="color: #006885 !important; border-bottom: 1px solid #006885;border-right: 1px solid #006885; border-style: dotted;">
											After Payment</td>
										<td class="fw-bolder text-center col-3" colspan="2"
											style="color: #006885 !important; border-bottom: 1px solid #006885;">Note:
										</td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="fw-bolder"
											style="color: #006885 !important; padding-left: 2rem !important;">Interest
											Due</td>
										<td
											style="color: #006885 !important;border-right: 1px solid #006885; border-style: dotted;">
											{{ displayNumber(calculatedDues.interestDue) }}</td>

										<td class="fw-bolder"
											style="color: #006885 !important;padding-left: 2rem !important;">Interest
										</td>
										<td
											style="color: #006885 !important;border-right: 1px solid #006885; border-style: dotted;">
											{{ displayNumber(getCurrentInterest) }}</td>

										<td class="fw-bolder"
											style="color: #006885 !important;padding-left: 2rem !important;">Interest
											Balance</td>
										<td
											style="color: #006885 !important; border-right: 1px solid #006885; border-style: dotted;">
											{{ displayNumber(afterInterestOutstanding) }}</td>

										<td class="fw-bolder"
											style="color: #006885 !important; border-bottom: 1px solid #006885; border-style: dotted;"
											colspan="2" rowspan="3"> {{ getNotes }} </td>
									</tr>

									<tr>
										<td style="color: #006885 !important; padding-left: 2rem !important;"
											class="fw-bolder">Principal Due</td>
										<td
											style="color: #006885 !important;border-right: 1px solid #006885; border-style: dotted;">
											{{ displayNumber(calculatedDues.principalDue) }}</td>


										<td style="color: #006885 !important; padding-left: 2rem !important;"
											class="fw-bolder">Principal</td>
										<td
											style="color: #006885 !important; border-right: 1px solid #006885; border-style: dotted;">
											{{ displayNumber(getCurrentPrincipal) }}</td>

										<td style="color: #006885 !important; padding-left: 2rem !important;"
											class="fw-bolder">Principal Balance</td>
										<td
											style="color: #006885 !important; border-right: 1px solid #006885; border-style: dotted;">
											{{ displayNumber(afterPrincipalOutstanding) }}</td>
									</tr>

									<tr>
										<td style="color: #006885 !important;border-bottom: 1px solid #006885; padding-left: 2rem !important;"
											class="fw-bolder">Total Expected</td>
										<td
											style="color: #006885 !important;border-right: 1px solid #006885; border-style: dotted;border-bottom: 1px solid #006885;">
											{{ displayNumber(totalExpected) }}</td>


										<td style="color: #006885 !important;border-bottom: 1px solid #006885; padding-left: 2rem !important;"
											class="fw-bolder">Total Payments</td>
										<td
											style="color: #006885 !important;border-bottom: 1px solid #006885; border-right: 1px solid #006885; border-style: dotted;">
											{{ displayNumber(getCurrentTotal) }}</td>

										<td style="color: #006885 !important;border-bottom: 1px solid #006885; padding-left: 2rem !important;"
											class="fw-bolder">Loan Balance</td>
										<td
											style="color: #006885 !important;border-bottom: 1px solid #006885; border-right: 1px solid #006885; border-style: dotted;">
											{{ displayNumber(afterTotalOutstanding) }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<!-- First -->
						<div class="col-4">
							<label class="akkurate-dark" for="payment_method">Payment Mode</label>
							<b-form-group id="payment_method" name="payment_method" label-for="payment_method">
								<multiselect id="payment_method" name="payment_method" @select="paymentType"
									class="mb-2 mt-2 field-container" aria-describedby="payment_method"
									v-model="form.payment_method" :allow-empty="false" :options="payment_options">
								</multiselect>
							</b-form-group>
						</div>
						<!--  -->

						<!-- Second -->
						<div class="col-4">
							<label class="akkurate-dark" for="amount">Amount</label>
							<b-form-group id="amount" label-for="amount">
								<b-form-input id="amount" name="amount" class="mb-2 mt-2 field-container fields"
									type="text" placeholder="Enter Amount" v-model="form.amount"
									:disabled="disabledAmount" @input="AmountInput"
									aria-describedby="amount"></b-form-input>
								<b-form-invalid-feedback>{{
									veeErrors.first("amount")
								}}</b-form-invalid-feedback>
								<errors v-if="form.errors.amount">
									{{ form.errors.amount[0] }}
								</errors>
							</b-form-group>
						</div>


						<div :class="(setoff || (marchmomo && !dmomo) || (dmomo && !marchmomo)) ? 'col-2' : 'col-4'">
							<label class="akkurate-dark" for="interest_payment">Interest</label>
							<b-form-group id="interest_payment" label-for="interest_payment">
								<b-form-input id="interest_payment" name="interest_payment"
									class="mb-2 mt-2 field-container fields" type="text"
									placeholder="Enter Interest Amount" v-model="form.interest_payment"
									:disabled="disablePrincipalInterest" @input="PrincipalInterestInput"
									aria-describedby="interest_payment"></b-form-input>
								<b-form-invalid-feedback>{{
									veeErrors.first("interest_payment")
								}}</b-form-invalid-feedback>
								<errors v-if="form.errors.interest_payment">
									{{ form.errors.interest_payment[0] }}
								</errors>
							</b-form-group>
						</div>


						<div :class="(setoff || (marchmomo && !dmomo) || (dmomo && !marchmomo)) ? 'col-2' : 'col-4'">
							<label class="akkurate-dark" for="principal_payment">Principal</label>
							<b-form-group id="principal_payment" label-for="principal_payment">
								<b-form-input id="principal_payment" name="principal_payment"
									class="mb-2 mt-2 field-container fields" type="text"
									placeholder="Enter Principal Amount" v-model="form.principal_payment"
									:disabled="disablePrincipalInterest" @input="PrincipalInterestInput"
									aria-describedby="principal_payment"></b-form-input>
								<b-form-invalid-feedback>{{
									veeErrors.first("principal_payment")
								}}</b-form-invalid-feedback>
								<errors v-if="form.errors.principal_payment">
									{{ form.errors.principal_payment[0] }}
								</errors>
							</b-form-group>
						</div>

						<div class="col-4" v-show="setoff">
							<label class="akkurate-dark" for="note">Product</label>
							<multiselect class="mt-2 field-container" v-model="form.product_id" label="account_number"
								:options="savings_accounts_options" :custom-label="productCustomLabel" selectLabel=""
								deselectLabel="" track-by="id">
							</multiselect>
						</div>

						<div class="col-4" v-show="marchmomo">
							<label class="akkurate-dark" for="momo_transaction_id">Momo Transaction ID</label>
							<b-form-group id="momo_transaction_id" label-for="momo_transaction_id">
								<b-form-input name="momo_transaction_id" id="momo_transaction_id"
									class="mb-2 mt-2 field-container fields" type="text"
									v-model="form.momo_transaction_id" placeholder="Enter Transaction ID">
								</b-form-input>
							</b-form-group>
						</div>

						<div class="col-4" v-show="dmomo">
							<label class="akkurate-dark" for="mobile">Mobile Number</label>
							<b-form-group id="mobile" label-for="mobile">
								<b-form-input class="mb-2 mt-2 field-container fields" type="text"
									v-model="form.mobile_number" placeholder="Enter Mobile Number"></b-form-input>
							</b-form-group>
						</div>

						<div class="col-4" v-if="cheque" v-show="cheque">
							<label class="akkurate-dark" for="check_number">Cheque No</label>
							<b-form-group id="check_number" label-for="check_number">
								<b-form-input id="check_number" name="check_number"
									class="mt-2 mb-2 field-container fields" type="text" v-model="form.check_number"
									placeholder="Enter Check Number" required></b-form-input>
							</b-form-group>
						</div>



						<div class="col-4">
							<label class="akkurate-dark" for="date">Date</label>
							<b-form-group id="date" label-for="date">
								<b-form-input class="mt-2 field-container fields" type="date" v-model="form.date"
									:disabled="repayment_date" required></b-form-input>
							</b-form-group>
						</div>

						<div class="col-4" v-show="cheque">
							<label class="akkurate-dark" for="bank_gl">Bank GL</label>
							<b-form-group id="bank_gl" label-for="bank_gl">
								<multiselect class="mt-2 mb-2 field-container" label="name"
									v-model="form.coa_subhead_id" :options="coa_subheads">
								</multiselect>
							</b-form-group>
						</div>

						<!-- Third -->


						<div class="col-4 mb-2">
							<label class="akkurate-dark" for="note">Note</label>
							<b-form-group id="note" label-for="note">
								<b-form-textarea class="mt-2 fields field-container" v-model="form.note"
									aria-describedby="note" placeholder="Enter Note...">
								</b-form-textarea>
								<b-form-invalid-feedback>{{
									veeErrors.first("note")
								}}</b-form-invalid-feedback>
								<errors v-if="form.errors.note">
									{{ form.errors.note[0] }}
								</errors>
							</b-form-group>
						</div>

						<div class="col-6 col-md-8" v-show="cash">
							<div>
								<label>Denomination</label>
								<denomination :denominations="form.denominations
									"></denomination>
							</div>
						</div>
					</div>
					<hr />
					<b-button :disabled="isSaving" type="submit"
						class="akkurate-green-btn me-2 btn-size float-right"><font-awesome-icon class="me-2"
							:icon="['fas', 'money-bill']" />{{ save }}</b-button>
					<b-button @click="clearForm" class="akkurate-gray-btn me-2 btn-size float-right"><font-awesome-icon
							class="me-2" :icon="['fas', 'close']" />Clear</b-button>
				</form>
			</div>
		</div>
		<cash-repayment ref="showCashRepayment" :reportData="reportData"></cash-repayment>
		<cheque-repayment ref="showChequeRepayment" :reportData="reportData"></cheque-repayment>
		<momo-merchant-repayment ref="showMerchantRepayment" :reportData="reportData"></momo-merchant-repayment>
		<direct-momo-debit-repayment ref="showDirectDebitRepayment"
			:reportData="reportData"></direct-momo-debit-repayment>
		<setoff-repayment ref="showSetOffRepayment" :reportData="reportData"></setoff-repayment>
	</div>
</template>
<script>
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import Denomination from "@/views/main/pages/transactions/form/modal/Denomination.vue";
import CashRepayment from "../../reports/cash/CashRepayment.vue";
import ChequeRepayment from "../../reports/cheque/ChequeRepayment.vue";
import MomoMerchantRepayment from "../../reports/momo/MomoMerchantRepayment.vue";
import DirectMomoDebitRepayment from "../../reports/direct-debit/DirectMomoDebitRepayment.vue";
import SetoffRepayment from "../../reports/set-off/SetoffRepayment.vue";
import { hasPermission } from "@/helper";
export default {
	watch: {
		'form.amount'(val) {
			if (val) this.formMode = 'amount';
		},
		'form.interest'(val) {
			if (val) this.formMode = 'manual';
		},
		'form.principal'(val) {
			if (val) this.formMode = 'manual';
		},
	},
	props: [
		"coa_subheads",
		"savings_accounts_options",
		"institution",
		"loan",
	],
	components: {
		Multiselect,
		Denomination,
		CashRepayment,
		ChequeRepayment,
		MomoMerchantRepayment,
		DirectMomoDebitRepayment,
		SetoffRepayment,
	},

	data() {
		return {
			...this.initialState(),
			isSaving: false,
			payment_options: [
				"Cash",
				"Cheque",
				"MOMO Merchant",
				"Direct MOMO Debit",
				"Set-Off",
			],
			cash: true,
			marchmomo: false,
			dmomo: false,
			cheque: false,
			setoff: false,
			reportData: [],
			save: "Pay",
			disabledAmount: false,
			disablePrincipalInterest: false,
			repayment_date: "",
			amount: 0,
			currentInterestOutstanding: 0,
			currentPrincipalOutstanding: 0,
			newInterest: 0,
			newPrincipal: 0,
			newInterestDue: 0,
			newPrincipalDue: 0,
			excessAmount: 0,
			formMode: 'amount', // Default mode is 'amount'
		};
	},
	mounted() {
		this.checkPemission();
	},
	computed: {
		// getPrincipalDue() {

		// 	let afterSubtract = Number(this.newPrincipalDue - (Number(this.getCurrentPrincipal) + Number(this.excessAmount)) || 0);
		// 	this.excessAmount = afterSubtract < 0 ? Math.abs(afterSubtract) : 0;

		// 	return afterSubtract < 0 ? 0 : afterSubtract;
		// },
		// getInterestDue() {
		// 	console.log("New Interest Due: ", this.newInterestDue);
		// 	let afterSubtract = Number(this.newInterestDue - (Number(this.getCurrentInterest) + Number(this.excessAmount)) || 0);

		// 	this.excessAmount = afterSubtract < 0 ? Math.abs(afterSubtract) : 0;

		// 	return afterSubtract < 0 ? 0 : afterSubtract;
		// },
		// calculatedDues() {
		// 	let interestDue = Number(this.newInterestDue);
		// 	let principalDue = Number(this.newPrincipalDue);
		// 	let principalBalance = 0;
		// 	let excess = 0;

		// 	// MODE 1: Using amount (auto allocation)
		// 	if (this.formMode === 'amount') {
		// 		let amount = Number(this.form.amount);

		// 		let remainingInterest = interestDue;
		// 		let remainingPrincipal = principalDue;

		// 		// Step 1: Allocate to interest
		// 		if (amount >= remainingInterest) {
		// 			this.newInterest = amount - remainingInterest
		// 			amount -= remainingInterest;
		// 			remainingInterest = 0;
		// 		} else {
		// 			remainingInterest -= amount;
		// 			amount = 0;
		// 		}

		// 		// Step 2: Allocate to principal
		// 		if (amount >= remainingPrincipal) {
		// 			this.newPrincipal = amount - remainingPrincipal
		// 			amount -= remainingPrincipal;
		// 			remainingPrincipal = 0;
		// 		} else {
		// 			remainingPrincipal -= amount;
		// 			amount = 0;
		// 		}

		// 		// Step 3: Extra goes to principal balance
		// 		principalBalance = amount > 0 ? amount : 0;
		// 		excess = 0;

		// 		return {
		// 			interestDue: remainingInterest,
		// 			principalDue: remainingPrincipal,
		// 			principalBalance,
		// 			excessAmount: excess,
		// 			mode: 'amount'
		// 		};
		// 	}

		// 	// MODE 2: Manual entry
		// 	else if (this.formMode === 'manual') {
		// 		// excess = 0;

		// 		// Step 1: Calculate remaining interest
		// 		// let interestDue = Number(this.newInterestDue);
		// 		let interestPaid = Number(this.getCurrentInterest);
		// 		let interestDueBalance = interestDue - interestPaid;

		// 		if (interestDueBalance < 0) {
		// 			excess = Math.abs(interestDueBalance);
		// 			interestDueBalance = 0;
		// 		}

		// 		// Step 2: Calculate remaining principal using any excess
		// 		// let principalDue = Number(this.newPrincipalDue);
		// 		let principalPaid = Number(this.getCurrentPrincipal);
		// 		let principalDueBalance = principalDue - (principalPaid + excess);

		// 		if (principalDueBalance < 0) {
		// 			excess = Math.abs(principalDueBalance);
		// 			principalDueBalance = 0;
		// 		} else {
		// 			excess = 0;
		// 		}

		// 		// Update shared state
		// 		this.excessAmount = excess;

		// 		return {
		// 			interestDue: interestDueBalance,
		// 			principalDue: principalDueBalance,
		// 			excessAmount: 0,
		// 			mode: 'manual'
		// 		};
		// 	}

		// 	// fallback
		// 	return {
		// 		interestDue,
		// 		principalDue,
		// 		principalBalance: 0,
		// 		excessAmount: 0,
		// 		mode: 'none'
		// 	};
		// }
		calculatedDues() {
			let interestDue = Number(this.newInterestDue);
			let principalDue = Number(this.newPrincipalDue);
			let principalBalance = 0;
			let excess = 0;

			if (this.formMode === 'amount') {
				let amount = Number(this.form.amount);

				let remainingInterest = interestDue;
				let remainingPrincipal = principalDue;

				if (amount >= remainingInterest) {
					this.newInterest = remainingInterest;
					amount -= remainingInterest;
					remainingInterest = 0;
				} else {
					remainingInterest -= amount;
					this.newInterest = amount;
					amount = 0;
				}

				if (amount >= remainingPrincipal) {
					this.newPrincipal = remainingPrincipal;
					amount -= remainingPrincipal;
					remainingPrincipal = 0;
				} else {
					remainingPrincipal -= amount;
					this.newPrincipal = amount;
					amount = 0;
				}

				principalBalance = amount > 0 ? amount : 0;
				excess = 0;

				return {
					interestDue: remainingInterest,
					principalDue: remainingPrincipal,
					principalBalance,
					excessAmount: excess,
					mode: 'amount'
				};
			} else if (this.formMode === 'manual') {
				// Use form inputs directly, no dependency on getCurrentInterest or getCurrentPrincipal
				let interestPaid = Number(this.form.interest_payment) || 0;
				let principalPaid = Number(this.form.principal_payment) || 0;

				let interestDueBalance = interestDue - interestPaid;
				if (interestDueBalance < 0) {
					excess = Math.abs(interestDueBalance);
					interestDueBalance = 0;
				}

				let principalDueBalance = principalDue - (principalPaid + excess);
				if (principalDueBalance < 0) {
					excess = Math.abs(principalDueBalance);
					principalDueBalance = 0;
				} else {
					excess = 0;
				}

				this.excessAmount = excess;

				return {
					interestDue: interestDueBalance,
					principalDue: principalDueBalance,
					principalBalance: 0,
					excessAmount: excess,
					mode: 'manual'
				};
			}

			return {
				interestDue,
				principalDue,
				principalBalance: 0,
				excessAmount: 0,
				mode: 'none'
			};
		},

		getCurrentInterest() {
			if (this.formMode === 'amount') {
				return this.newInterestDue - this.calculatedDues.interestDue;
			} else if (this.formMode === 'manual') {
				return this.calculatedDues.interestDue;
			}
			return 0;
		},

		getCurrentPrincipal() {
			if (this.formMode === 'amount') {
				const paidToPrincipalDue = this.newPrincipalDue - this.calculatedDues.principalDue;
				const paidToBalance = this.calculatedDues.principalBalance || 0;
				return paidToPrincipalDue + paidToBalance;
			} else if (this.formMode === 'manual') {
				return this.calculatedDues.principalDue;
			}
			return 0;
		},
		getCurrentTotal() {
			return (Number(this.getCurrentPrincipal) + Number(this.getCurrentInterest)) || 0
		},
		totalExpected() {
			return Number(this.calculatedDues.interestDue) + Number(this.calculatedDues.principalDue) || 0;
		},
		afterInterestOutstanding() {
			// Remaining interest = interest outstanding - interest paid
			const paidInterest = this.newInterestDue - this.calculatedDues.interestDue;
			const afterInterest = this.currentInterestOutstanding - paidInterest;
			return Math.max(afterInterest, 0).toFixed(2);
		},

		afterPrincipalOutstanding() {
			const paidPrincipal = this.newPrincipalDue - this.calculatedDues.principalDue + (this.calculatedDues.principalBalance || 0);
			const afterPrincipal = this.currentPrincipalOutstanding - paidPrincipal;
			return Math.max(afterPrincipal, 0).toFixed(2);
		},

		afterTotalOutstanding() {
			return (parseFloat(this.afterInterestOutstanding) + parseFloat(this.afterPrincipalOutstanding)).toFixed(2);
		},
		getNotes() {
			return this.form.note
		},


	},
	methods: {
		getPaymentDetails() {
			// console.log(this.loan)
			this.currentInterestOutstanding = this.loan.interest_balance;
			this.currentPrincipalOutstanding = this.loan.principal_balance;
			this.newInterestDue = this.loan.interest_due;
			this.newPrincipalDue = this.loan.principal_due;
		},
		checkPemission() {
			this.repayment_date = !hasPermission(
				"loan_management_repayment_date"
			);
		},
		customLabel({ account_type, account_number }) {
			return `${account_number} - ${account_type?.name}`;
		},
		productCustomLabel({
			account_balance,
			account_number,
			account_type,
		}) {
			this.getPaymentDetails();
			return `${account_number} ${account_type.name} - (${this.institution.currency_code
				}${this.displayNumber(account_balance)})`;
		},
		handleSubmit(event) {
			event.preventDefault();
			this.saveTransaction(this.form.payment_method);
			// switch (this.form.payment_method) {
			//     case "Cash":
			//         this.saveCash();
			//         this.clearForm()
			//         break;
			//     case "MOMO Merchant":
			//         this.saveMomoMarchant();
			//         this.clearForm()
			//         break;
			//     case "Direct Momo Debit":
			//         this.saveDirectMomoDirect();
			//         this.clearForm()
			//         break;
			//     case "Cheque":
			//         this.saveCheque();
			//         this.clearForm()
			//         break;
			//     case "Set-Off":
			//         this.saveSetOff();
			//         this.clearForm()
			//         break;
			// }
			// Hide the modal manually
		},
		AmountInput(index) {
			// console.log(index.length)
			if (this.formMode === 'manual') {
				this.formMode = 'amount'; // Switch to amount mode if manual was previously selected
			}
			if (index.length > 0) {
				this.disablePrincipalInterest = true;
				this.form.principal_payment = "";
				this.form.interest_payment = "";
			} else {
				this.disablePrincipalInterest = false;
			}
		},
		PrincipalInterestInput(index) {
			if (this.formMode === 'amount') {
				this.formMode = 'manual'; // Switch to manual mode if amount was previously selected
				console.log("Switched to manual mode", this.formMode);
			}
			if (index.length > 0) {
				this.disabledAmount = true;
				this.form.amount = "";
			} else {
				this.disabledAmount = false;
			}
		},
		paymentType(value) {
			switch (value) {
				case "Cash":
					this.cash = true;
					this.dmomo = false;
					this.marchmomo = false;
					this.cheque = false;
					this.setoff = false;
					this.form.denominations = [
						{
							denom_amount: "1",
							denom_frequency: "",
							sub_total: "",
						},
					];
					this.form.mobile_number = "";
					this.form.check_number = "";
					this.form.momo_transaction_id = "";
					this.form.coa_subhead_id = "";
					this.form.product_id = "";
					break;
				case "MOMO Merchant":
					this.dmomo = true;
					this.marchmomo = true;
					this.cheque = false;
					this.setoff = false;
					this.cash = false;
					this.form.denominations = [];
					this.form.check_number = "";
					this.form.coa_subhead_id = "";
					this.form.product_id = "";
					break;
				case "Direct MOMO Debit":
					this.dmomo = true;
					this.marchmomo = false;
					this.cheque = false;
					this.setoff = false;
					this.cash = false;
					this.form.denominations = [];
					this.form.check_number = "";
					this.form.coa_subhead_id = "";
					this.form.product_id = "";
					break;

				case "Cheque":
					this.dmomo = false;
					this.cheque = true;
					this.marchmomo = false;
					this.setoff = false;
					this.cash = false;
					this.form.denominations = [];
					this.form.mobile_number = "";
					this.form.momo_transaction_id = "";
					this.form.product_id = "";
					break;
				case "Set-Off":
					this.dmomo = false;
					this.cheque = false;
					this.marchmomo = false;
					this.setoff = true;
					this.cash = false;
					this.form.denominations = [];
					this.form.mobile_number = "";
					this.form.check_number = "";
					this.form.momo_transaction_id = "";
					break;
				default:
					this.dmomo = false;
					this.marchmomo = false;
					this.cheque = false;
					this.note = false;
					this.setoff = false;
					this.cash = false;
					this.form.denominations = [];
					break;
			}
		},
		clearForm() {
			this.form = this.initialState().form; // Call the initialState method to get the default form
		},

		async saveTransaction(payment) {
			this.isSaving = true;
			this.$Progress.start();
			this.form.loan_number = this.loan.loan_number;
			this.form.payment_method = payment;
			// this.form.product_id = null;
			if (this.form.payment_method === "Cheque") {
				this.form.coa_subhead_id = this.form.coa_subhead_id.id;
			} else {
				this.form.coa_subhead_id;
			}
			if (this.form.payment_method === "Set-Off") {
				this.form.product_id = this.form.product_id.id;
			} else {
				this.form.product_id;
			}

			this.save = "Processing...";



			if (this.form.principal_payment == "" && this.form.interest_payment == "") {
				await ApiService.post("/loans/loanRepayments", this.form)
					.then((response) => {
						let res = response?.data;
						// console.log(res);
						this.$Progress.finish();
						this.save = "Pay";
						this.reportData = {
							trans_date: res?.transaction?.trans_date,
							// 'transaction': res?.transaction,
							// 'loan': res?.loan,
							denominations: this.form.denominations,
							institution: this.institution,
							teller:
								res.teller.first_name +
								" " +
								res.teller.surname,
							account_number: res.loan.account.account_number,
							loan_number: res.loan.loan_number,
							fullname:
								res.loan.customer.first_name +
								" " +
								res.loan.customer.last_name,
							transaction_mode:
								res.transaction.transaction_mode,
							amount: res.transaction.trans_amount,
							denomination: res.transaction.denominations,
							transaction_type:
								res.transaction.transaction_type,
							cheque_number: res.transaction.cheque_number,
							bank_name: res.bank_name,
							merchant_number:
								res.transaction.merchant_number,
							transaction_id: res.transaction.code,
							mobile: res.transaction.mobile,
						};

						this.$emit("reloadLoans");
						this.paymentType(res.transaction.transaction_type);

						this.isSaving = false;
						swal.fire({
							title: "Success",
							text: response.data.message,
							// text: "Saved successfully",
							confirmButtonColor: "#018673",
							icon: "success",
							allowOutsideClick: false,
							allowEscapeKey: false,
							showCancelButton: true, // Show the "Cancel" button
							confirmButtonText: "OK", // Customize the text for the "OK" button
							cancelButtonText: "Print", // Text for the custom button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								cancelButton:
									"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
							},
						}).then((result) => {
							if (result.isConfirmed) {
								this.$bvModal.hide("loan_repayment");
							} else if (result.isDismissed) {
								switch (payment) {
									case "Cash":
										if (res.transaction.transaction_type == "Loan Repayment") {
											this.$refs.showCashRepayment.showModal();
										}
										else if (res.transaction.transaction_type == "Loan Disbursed") {
											this.$refs.showCashDisbursement.showModal();
										}
										break;
									case "Cheque":
										if (res.transaction.transaction_type == "Loan Repayment") {
											this.$refs.showChequeRepayment.showModal();
										} else if (
											res.transaction
												.transaction_type ==
											"Loan Disbursed"
										) {
											this.$refs.showChequeDisbursement.showModal();
										}
										break;
									case "MOMO Merchant":
										if (
											res.transaction
												.transaction_type ==
											"Loan Repayment"
										) {
											this.$refs.showMerchantRepayment.showModal();
										} else if (
											res.transaction
												.transaction_type ==
											"Loan Disbursed"
										) {
											this.$refs.showMerchantDisbursement.showModal();
										}
										break;
									case "Direct MOMO Debit":
										if (
											res.transaction
												.transaction_type ==
											"Loan Repayment"
										) {
											// console.log(payment);
											// console.log(
											// 	res.transaction
											// 		.transaction_type
											// );
											this.$refs.showDirectDebitRepayment.showModal();
										} else if (
											res.transaction
												.transaction_type ==
											"Loan Disbursed"
										) {
											this.$refs.showDirectDebitDisbursement.showModal();
										}
										break;
									case "Set-Off":
										if (res.transaction.transaction_type == "Loan Repayment") {
											// console.log(this.$refs.showSetOffRepayment);
											this.$refs.showSetOffRepayment.showModal();
										} else if (
											res.transaction
												.transaction_type ==
											"Loan Disbursed"
										) {
											this.$refs.showSetOffDisbursement.showModal();
										}
										break;
								}
							}

							this.getPaymentDetails();
						});
					})
					.catch((error) => {
						this.save = "Pay";
						this.isSaving = false;
						this.$Progress.fail();
						// if (error.response?.status == 422) {
						swal.fire({
							icon: "error",
							title: "Error",
							text: error.response?.data?.message,
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: "OK", // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
							// footer: '<a href="#">Why do I have this issue?</a>'
						});
						// }
					});
			} else {
				await ApiService.post(
					"/loans/custom/repayment/store",
					this.form
				)
					.then((response) => {
						let res = response?.data;
						// console.log(res);
						this.$Progress.finish();
						this.save = "Pay";
						this.reportData = {
							trans_date: res?.transaction?.trans_date,
							// 'transaction': res?.transaction,
							// 'loan': res?.loan,
							denominations: this.form.denominations,
							institution: this.institution,
							teller:
								res.teller.first_name +
								" " +
								res.teller.surname,
							account_number: res.loan.account.account_number,
							loan_number: res.loan.loan_number,
							fullname:
								res.loan.customer.first_name +
								" " +
								res.loan.customer.last_name,
							transaction_mode:
								res.transaction.transaction_mode,
							amount: res.transaction.trans_amount,
							denomination: res.transaction.denominations,
							transaction_type:
								res.transaction.transaction_type,
							cheque_number: res.transaction.cheque_number,
							bank_name: res.bank_name,
							merchant_number:
								res.transaction.merchant_number,
							transaction_id: res.transaction.code,
							mobile: res.transaction.mobile,
						};

						this.$emit("reloadLoans");
						this.paymentType(res.transaction.transaction_type);

						this.isSaving = false;
						swal.fire({
							title: "Success",
							text: response.data.message,
							// text: "Saved successfully",
							confirmButtonColor: "#018673",
							icon: "success",
							allowOutsideClick: false,
							allowEscapeKey: false,
							showCancelButton: true, // Show the "Cancel" button
							confirmButtonText: "OK", // Customize the text for the "OK" button
							cancelButtonText: "Print", // Text for the custom button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								cancelButton:
									"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
							},
						}).then((result) => {
							if (result.isConfirmed) {
								this.$bvModal.hide("loan_repayment");
							} else if (result.isDismissed) {
								switch (payment) {
									case "Cash":
										if (
											res.transaction
												.transaction_type ==
											"Loan Repayment"
										) {
											this.$refs.showCashRepayment.showModal();
										} else if (
											res.transaction
												.transaction_type ==
											"Loan Disbursed"
										) {
											this.$refs.showCashDisbursement.showModal();
										}
										break;
									case "Cheque":
										if (
											res.transaction
												.transaction_type ==
											"Loan Repayment"
										) {
											this.$refs.showChequeRepayment.showModal();
										} else if (
											res.transaction
												.transaction_type ==
											"Loan Disbursed"
										) {
											this.$refs.showChequeDisbursement.showModal();
										}
										break;
									case "MOMO Merchant":
										if (
											res.transaction
												.transaction_type ==
											"Loan Repayment"
										) {
											this.$refs.showMerchantRepayment.showModal();
										} else if (
											res.transaction
												.transaction_type ==
											"Loan Disbursed"
										) {
											this.$refs.showMerchantDisbursement.showModal();
										}
										break;
									case "Direct MOMO Debit":
										if (
											res.transaction
												.transaction_type ==
											"Loan Repayment"
										) {
											// console.log(payment);
											// console.log(
											// 	res.transaction
											// 		.transaction_type
											// );
											this.$refs.showDirectDebitRepayment.showModal();
										} else if (
											res.transaction
												.transaction_type ==
											"Loan Disbursed"
										) {
											this.$refs.showDirectDebitDisbursement.showModal();
										}
										break;
									case "Set-Off":
										if (
											res.transaction
												.transaction_type ==
											"Loan Repayment"
										) {
											// console.log(data.item.transaction_type)
											// console.log(
											// 	this.$refs
											// 		.showSetOffRepayment
											// );
											this.$refs.showSetOffRepayment.showModal();
										} else if (
											res.transaction
												.transaction_type ==
											"Loan Disbursed"
										) {
											this.$refs.showSetOffDisbursement.showModal();
										}
										break;
								}
							}
						});
					})
					.catch((error) => {
						this.save = "Pay";
						this.isSaving = false;
						this.$Progress.fail();
						// if (error.response?.status == 422) {
						swal.fire({
							icon: "error",
							title: "Error",
							text: error.response?.data?.message,
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: "OK", // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
							// footer: '<a href="#">Why do I have this issue?</a>'
						});
						// }
						this.getPaymentDetails();
					});
			}
		},

		initialState() {
			return {
				form: {
					amount: "",
					payment_method: "Cash",
					date: new Date().toLocaleDateString("en-CA"),
					loan_number: "",
					source: "OFFICE",
					note: "",
					bank: "",
					mobile_number: "",
					check_number: "",
					momo_transaction_id: "",
					denominations: [
						{
							denom_amount: "1",
							denom_frequency: "",
							sub_total: "",
						},
					],
					coa_subhead_id: null,
					product_id: null,
					product: null,
					errors: [],
					principal_payment: "",
					interest_payment: "",
				},
			};
		},
	},
};
</script>
